import { combineReducers } from "redux";
import { ACTION } from "./constants";

const initialState = {
  courses: [],
  childEducation: {},
};
export default function LearnsCornersReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION.GET_EDU_COURSES_CONTENT:
      return {
        ...state,
        courses: [...action.data],
      };
    case ACTION.LEARN_STNDOTP:
      return { ...state, learnOtpResponse: action.data };
    case ACTION.CLEAR_LEARN_STNDOTP:
      return { ...state, learnOtpResponse: false };
    case ACTION.LEARN_VERIFYOTPDATA:
      return { ...state, learnVerifyOtpResponse: action.data };
    case ACTION.CLEAR_LEARN_VERIFYOTPDATA:
      return { ...state, learnVerifyOtpResponse: {} };
    case ACTION.TOOLS_CALLBACK:
      return { ...state, learnCallBack: action.data };
    case ACTION.CLEAR_LEARN_TOOLS_CALLBACK:
      return { ...state, learnCallBack: {} };
    case ACTION.CALCULATE_TOPUP_SIP:
      return { ...state, topUpSipResult: action.data };
    case ACTION.CORNER_LEVELS:
      return { ...state, learnLevels: action.data };
    case ACTION.LEARN_SUBSCRIPTION:
      return { ...state, learnSubscription: action.data };
    case ACTION.CORNER_LEVELS_DATA:
      return { ...state, learnLevelsDetail: action.data };
    case ACTION.CORNER_SEARCH:
      return { ...state, learnSearch: action.data };
    case ACTION.SAVE_FEEDBACK:
      return { ...state, saveFeedbackResp: action.data };
    case ACTION.INVESTOR_AWARENESS:
      return { ...state, investerAwarenessList: action.data };
    case ACTION.LEARN_INVESTOR_FAQS:
      return { ...state, investerAwarenessFaqs: action.data };
    case ACTION.GET_STATE_DATA:
      return { ...state, investorawarenessSatate: action.data };
    case ACTION.POST_SUBMIT_REGISTER_DATA:
      return { ...state, submitRegisterResponseData: action.data };
    case ACTION.GET_IAP_DOWNLOADS:
      return { ...state, cornerIapDocuments: action.data };
    case ACTION.POST_IAP_DOWNLOAD_SEARCH:
      return { ...state, cornerIapDocuments: action.data };
    case ACTION.GET_KEY_INFORMATION:
      return { ...state, cornerKYC: action.data };
    case ACTION.CORNER_SECTION_OVERVIEW:
      return { ...state, cornerOverview: action.data };
    case ACTION.CORNER_LIST:
      return { ...state, cornerList: action.data };
    case ACTION.CORNER_VIDEO_SECTION:
      return { ...state, cornerVideo: action.data };
    case ACTION.CORNER_PODCAST_SECTION:
      return { ...state, cornerPodcast: action.data };
    case ACTION.GET_CORNER_PODCAST_DETAILS:
      return { ...state, cornerPodcastDetails: action.data };
    case ACTION.TOOLS_CALCULATE:
      return { ...state, toolsCalculator: action.data };
    case ACTION.GET_IAP_MONTH_CORNER:
      return { ...state, iapMonthDefault: action.data };
    case ACTION.CLEAR_SAVE_FEEDBACK:
      return { ...state, saveFeedbackResp: {} };
    case ACTION.GET_CALCULATOR_METADATA:
      return { ...state, calciMetaData: action.data };
    case ACTION.GET_MFBYTES_METADATA:
      return { ...state, mfbyesmetaData: action.data };
    case ACTION.GET_BOOK_REVIEW_DATA:
      return { ...state, bookReviewData: action.data };
    case ACTION.BOOK_REVIEW_DETAILS:
      return { ...state, bookReviewDetailsData: action.data };
    case ACTION.BOOK_REVIEW_COUNT:
      return { ...state, bookReviewCountData: action.data };
    case ACTION.GET_CORNER_VIDEO_DETAILS:
      return { ...state, videoDetailData: action.data };
    case ACTION.POETRY_LOUNGE:
      return { ...state, poetryData: action.data };
    case ACTION.THE_READING_ROOM:
      return { ...state, readingRoomData: action.data };
    default:
      return state;
  }
}
